export const DOCUMENT_FUNCTIONS = {
  factuur: 'facturen', offerte: 'offertes', bestelbon: 'bestelbonnen',
  leverbon: 'leveringsbonnen', proforma: 'proforma', creditnota: 'creditnotas',
};

// Only navigation is filtered. Existing document URLs and API permissions are unchanged.
export function routeFunction(url, functies = {}) {
  const [path, query = ''] = (url || '').split('?');
  if (path === '/instellingen' || path.startsWith('/instellingen/')) return 'instellingen';
  if (path === '/inventaris' || path.startsWith('/inventaris/')) return 'voorraad';
  if (path === '/documenten' || path.startsWith('/documenten/')) {
    const type = new URLSearchParams(query).get('type') || path.split('/')[2];
    return DOCUMENT_FUNCTIONS[type] || null;
  }
  return Object.keys(functies).sort((a, b) => b.length - a.length)
    .find(key => path === `/${key}` || path.startsWith(`/${key}/`)) || null;
}

export const functionTestId = key => key.replaceAll('/', '-');